import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";

import Info from "../Info";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { useContent } from "../../content/useContent";
import { translator } from "../../utils/translations/translator";
import {
  directoryCategoriesAr,
  directoryStatusAr,
} from "../../utils/translations";

type IProps = {
  handleClick: any;
  row: any;

  handleOpenDelete: any;
  handleEdit: any;
};

const classes = {
  between: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
  },
  category: {
    fontWeight: "bold",
  },
};

const ListItem: React.FC<IProps> = ({
  handleClick,
  row,

  handleOpenDelete,
  handleEdit,
}) => {
  const { isRTL } = useRTL();
  const { general, pages } = useContent();
  const { directories } = pages;
  return (
    <Card>
      <CardActionArea onClick={() => handleClick(row.id)}>
        <CardContent sx={{ pt: 1, pr: 1 }}>
          <Box sx={classes.between}>
            <Typography
              variant="h5"
              component="h5"
              color="primary"
              sx={classes.title}
            >
              {row.name}
            </Typography>
            <CardActions disableSpacing sx={{ p: 0 }}>
              <Tooltip title={general.edit}>
                <IconButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleEdit(row.id);
                  }}
                >
                  <EditIcon color="primary" />
                </IconButton>
              </Tooltip>
              <Tooltip title={general.delete}>
                <IconButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleOpenDelete(row);
                  }}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              </Tooltip>
            </CardActions>
          </Box>

          <Grid container>
            <Grid item xs={6} md={5}>
              <Info
                title={directories.category}
                description={
                  isRTL
                    ? translator(row.category, directoryCategoriesAr)
                    : row.category
                }
                my={1}
              />
            </Grid>
            <Grid item xs={6} md={5}>
              <Info
                title={directories.status}
                description={
                  isRTL ? translator(row.status, directoryStatusAr) : row.status
                }
                my={1}
              />
            </Grid>
            <Grid item xs={6} md={5}>
              <Info
                title={directories.reservable}
                description={
                  isRTL
                    ? translator(row.reservable, directoryStatusAr)
                    : row.reservable
                }
                my={1}
              />
            </Grid>
            <Grid item xs={6} md={5}>
              <Info
                title={directories.comingSoon}
                description={row.comingSoon ? directories.yes : directories.no}
                my={1}
              />
            </Grid>
            <Grid item xs={12} md={7}>
              <Info
                title={directories.openingHours}
                description={row.openingHours}
                my={1}
              />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ListItem;
